module.exports = __webpack_public_path__ + "media/icons/map-pin@2x-3a5a3e54.png";